export default {
  beforeRouteEnter: (from, to, next) => {
    next('/Home');
  },
};
